import React from "react";

function WeatherCard({ weather }) {
  const iconUrl = `http://openweathermap.org/img/wn/${weather.weather[0].icon}@2x.png`;

  return (
    <div className="weather-card">
      <h2>{weather.name}</h2>
      <h3>{weather.weather[0].main}</h3>
      <img src={iconUrl} alt={weather.weather[0].description} />
      <p>{weather.weather[0].description}</p>
      <h1>{Math.round(weather.main.temp)}°C</h1>
      <p>Humidity: {weather.main.humidity}%</p>
      <p>Wind Speed: {weather.wind.speed} m/s</p>
    </div>
  );
}

export default WeatherCard;
